// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__9w660","textareaLabel":"Textarea_textareaLabel__Q8STa","textareaError":"Textarea_textareaError__IuBl7"};